<template>
    <div class="flex-level flex-top">
        <div class="flex flex-row">
            <avatar :avatar="third.avatar" size="big" />
            <div class="dinlineb valign-middle ml-3">
                <h4 class="mt-0 mb-1">
                    <CompassLink
                        :label="third.name"
                        :link="'/thirds/' + third.relationType + '/' + third.id"
                    />
                </h4>
                <span v-if="third.type" class="fs-3 gray-60 capitalize">
                    {{ relationTypeTranslated }}
                </span>
            </div>
        </div>

        <!-- CTA -->
        <div class="flex">
            <ul class="m-0">
                <!-- EMAIL -->
                <li v-if="third.email !== ''" class="mb-1 fs-3 mb-1 copy-element">
                    <i class="icon-email mr-2 gray-60"></i>
                    <email-link
                        linkedtype="third"
                        :linkedid="parseInt(third.id)"
                        :disabled="third.isArchived"
                        :email="third.email"
                        class="regular"
                    >
                        {{ third.email }}
                    </email-link>
                    <SaasClipboard :data="third.email" tooltipPlacement="right" />
                </li>
                <!-- PHONE -->
                <li v-if="third.phone !== ''" class="mb-1 fs-3 mb-1 copy-element">
                    <i class="icon-sellsyphone mr-2 gray-60"></i>
                    <CompassLink
                        :label="third.phone"
                        :link="phonecallProtocol + ':' + third.phone.replace(/[^\+\d]/g, '')"
                    />
                    <SaasClipboard :data="third.phone" tooltipPlacement="right" />
                </li>
                <!-- MOBILE -->
                <li v-if="third.mobile !== ''" class="mb-1 fs-3 mb-1 copy-element">
                    <i class="icon-sellsyphone mr-2 gray-60"></i>
                    <CompassLink
                        :label="third.mobile"
                        :link="phonecallProtocol + ':' + third.mobile.replace(/[^\+\d]/g, '')"
                    />
                    <SaasClipboard :data="third.mobile" tooltipPlacement="right" />
                </li>
            </ul>
        </div>
        <div>
            <el-dropdown>
                <a href="javascript:;" class="btn-icon"><i class="icon-burger"></i></a>
                <template #dropdown>
                    <el-dropdown-menu>
                        <el-dropdown-item
                            v-for="(action, index) in third.actions"
                            :key="index"
                            :disabled="!hasAccess(action.permission, permissions)"
                            :class="
                                !hasAccess(action.permission, permissions) ? 'link-disabled' : ''
                            "
                        >
                            <a
                                v-if="action.type === 'vuejs'"
                                :class="
                                    !hasAccess(action.permission, permissions)
                                        ? 'link-disabled'
                                        : ''
                                "
                                @click="$emit('clicked', action.value, third)"
                            >
                                {{ action.label }}
                            </a>
                            <a
                                v-else
                                :href="action.value"
                                :class="
                                    !hasAccess(action.permission, permissions)
                                        ? 'link-disabled'
                                        : ''
                                "
                            >
                                {{ action.label }}
                            </a>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </template>
            </el-dropdown>
        </div>
    </div>
</template>

<script>
import TagHumansConfig from 'Config/authenticated/TagHumans';
import EmailLink from 'vcomponents/email/EmailLink.vue';
import Avatar from 'vcomponents/utilities/Avatar.vue';
import { hasAccess } from '../../helpers';
import { createNamespacedHelpers } from 'vuex';
import SaasClipboard from 'vcomponents/utilities/SaasClipboard.vue';
const { mapState } = createNamespacedHelpers('corp');

export default {
    components: {
        SaasClipboard,
        'email-link': EmailLink,
        Avatar,
    },
    props: {
        third: {
            type: Object,
            required: true,
            default: () => {},
        },
        permissions: {
            type: [Array, Object],
            required: false,
            default: () => [],
        },
    },
    data() {
        return {};
    },
    computed: {
        relationTypeTranslated: function () {
            return TagHumansConfig[this.third.relationType].label;
        },
        ...mapState(['phonecallProtocol']),
    },
    methods: {
        hasAccess,
        onCopy: function () {
            Push.success(this.$l10n.__('Copié dans votre presse-papier'));
        },
        onError: function () {
            Push.error(this.$l10n.__('Erreur lors de la copie dans votre presse-papier'));
        },
    },
};
</script>

<style lang="scss" scoped>
@use '~@sellsy/styleguide/src/_variables' as *;

.copy-btn {
    display: inline-block;
    transform: translateX(-100%);
    opacity: 0;
    transition: all 0.3s linear;
}

.copy-element:hover {
    .copy-btn {
        transform: translateX(0);
        opacity: 1;
        color: $gray-100;
        cursor: pointer;

        &:hover {
            color: $primary-50;
        }
    }
}
</style>
